import { Component, OnInit, inject } from "@angular/core";
import { Visit } from "@app/models/rest/visit";
import { BehaviorSubject, Observable } from "rxjs";
import { VisitStore } from "@app/services/store/visit-store";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet
} from "@angular/router";

@Component({
  selector: "app-booking-container",
  templateUrl: "./booking-container.component.html",
  styleUrls: ["./booking-container.component.scss"],
  imports: [RouterOutlet]
})
export class BookingContainerComponent implements OnInit {
  visitStore = inject(VisitStore);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);
  route = inject(ActivatedRoute);
  router = inject(Router);

  public loading: boolean = true;
  protected visitsSubject: BehaviorSubject<Visit[]>;
  protected firstLoad = true;

  constructor() {
    const route = this.route;

    console.log("route");
    console.log(route);
    this.visitsSubject = new BehaviorSubject<Visit[]>([]);
    this.router.events.subscribe((event) => {
      console.log(event);
      if (event instanceof NavigationEnd) {
        this.refresh();
      }
    });
  }

  get visits(): Observable<Visit[]> {
    return this.visitsSubject.asObservable();
  }

  ngOnInit() {
    console.log("ngOnInit booking container");
    this.refresh();
  }

  private refresh() {
    this.loading = true;
    this.visitStore
      .loadWithSearch(
        "findAllByVisitStatusOrderByJobPlanningWindowEnd",
        {
          params: {
            projection: "basic",
            status: "NEW"
          },
          pageParams: {
            size: 999
          }
        },
        true
      )
      .then((visits) => {
        this.visitsSubject.next(visits.resources);
        this.loading = false;
      });
  }
}
